"use client";

import { useCallback } from "react";
import { Button } from "@workspace/ui/components/button";
import { EventNames, SectionTypes, sendEvent, withSectionType } from "@/lib/utils/analytics";
import { useQuizState } from "@/components/quiz/hooks/use-quiz-state";
import { isQuizTouchpointExperiment } from "@/lib/quiz-attribution";
import { useQuizTouchpointImpression } from "@/components/quiz/hooks/use-quiz-touchpoint-impression";

function ControlCta() {
  function handleClick() {
    sendEvent(
      EventNames.HOW_INITO_WORK_CLICKED,
      withSectionType(SectionTypes.HERO_BANNER),
    );
    const el = document.getElementById("how-it-works");
    if (el) {
      const top = el.getBoundingClientRect().top + window.scrollY - 40;
      window.scrollTo({ top, behavior: "smooth" });
    }
  }

  return (
    <Button
      id="hero-cta"
      data-testid="hero-cta"
      variant="white"
      size="default"
      className="w-[201px] lg:rounded-[14px] lg:px-[30px] lg:py-[15px] lg:title-18"
      onClick={handleClick}
    >
      How does it work?
    </Button>
  );
}

function ExperimentCta() {
  const { handleQuizTap, ctaLabel } = useQuizState();
  const ref = useQuizTouchpointImpression<HTMLButtonElement>("hero_section");

  const handleClick = useCallback(() => {
    handleQuizTap("hero_section");
  }, [handleQuizTap]);

  return (
    <Button
      ref={ref}
      id="hero-cta"
      data-testid="hero-cta"
      variant="white"
      size="default"
      className="w-[201px] lg:rounded-[14px] lg:px-[30px] lg:py-[15px] lg:title-18"
      onClick={handleClick}
    >
      {ctaLabel}
    </Button>
  );
}

export function HeroCta() {
  if (isQuizTouchpointExperiment()) {
    return <ExperimentCta />;
  }
  return <ControlCta />;
}
